import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import offline from './offline'
import axios from 'axios'

Vue.use(Vuex)

const session = {
  namespaced: true,

  state: () => ({
    session: {
      access: '',
      refresh: '',
    },
    localStorage: false
  }),

  mutations: {
    SET_SESSION_DATA(state, data) {
      const session = {
        access: data.access? data.access : data.access,
        refresh: data.refresh,
        user: data.user,
      }
      state.session = session

      if (!data.alreadyLoaded) {
        state.localStorage = data.remember
        if (data.remember) {
          localStorage.setItem('session', JSON.stringify(session))
        } else {
          sessionStorage.setItem('session', JSON.stringify(session))
        }
        // console.log(this.commit)
        // dispatch('session/setSelectedCompany', data.selected_company)

      }
    },

    CLEAR_SESSION_DATA(state) {
      // state.user = null
      state.localStorage = false,
      state.session = {
        access: '',
        refresh: '',
      }
      sessionStorage.removeItem('session')
      localStorage.removeItem('session')
    },

    REFRESH_TKN(state, data) {
      state.session.access = data.access
      if (data.refresh) state.session.refresh = data.refresh
      const storage = state.localStorage ? localStorage : sessionStorage
      storage.setItem('session', JSON.stringify(state.session))
    },

    UPDATE_USER_PHOTO(state, photoUrl) {
      if (state.session.user) {
        state.session.user.photo = photoUrl
        const storage = state.localStorage ? localStorage : sessionStorage
        storage.setItem('session', JSON.stringify(state.session))
      }
    },

    CLEAR_MUST_CHANGE_PASSWORD(state) {
      if (state.session.user) {
        state.session.user.must_change_password = false
        const storage = state.localStorage ? localStorage : sessionStorage
        storage.setItem('session', JSON.stringify(state.session))
      }
    },

  },

  actions: {
    setSessionData({ commit }, session_data) {
      commit('SET_SESSION_DATA', session_data)
    },
    logoutUser({ commit }) {
      commit('CLEAR_SESSION_DATA')
    },
    updateUserPhoto({ commit }, photoUrl) {
      commit('UPDATE_USER_PHOTO', photoUrl)
    },
    clearMustChangePassword({ commit }) {
      commit('CLEAR_MUST_CHANGE_PASSWORD')
    },
  },

  getters: {
    logged: (state) => () => { return !! state.session?.access?.length },
    get_token: (state) => () =>{ return state.session?.access },
    refresh: (state) => () =>{ return state.session?.refresh },
    userData: (state) => () =>{ return state.session?.user },
    getUserRole: (state) => () =>{ return state.session?.user?.role },
  },
}


const FILTERS_KEY = 'listFilters'

const defaultFilters = () => ({
  evaluations: {
    searchQuery: '',
    countryFilter: -1,
    zoneFilter: -1,
    regionFilter: -1,
    yearFilter: -1,
    statusFilter: -1,
    downloadedOfflineFilter: false,
    current_page: 1,
    page_size: 10,
  },
  schools: {
    searchQuery: '',
    countryFilter: -1,
    stateFilterZone: -1,
    current_page: 1,
    page_size: 25,
    sortDesc: false,
  },
})

const loadFilters = () => {
  const base = defaultFilters()
  try {
    const stored = JSON.parse(localStorage.getItem(FILTERS_KEY))
    if (!stored) return base
    const evaluations = { ...base.evaluations, ...stored.evaluations }
    // Before the Region→Zone refactor regionFilter stored a zone *name*; it is now a Region id.
    if (typeof evaluations.regionFilter !== 'number') evaluations.regionFilter = -1
    return {
      evaluations,
      schools: { ...base.schools, ...stored.schools },
    }
  } catch (e) {
    return base
  }
}

const listFilters = {
  namespaced: true,

  state: () => loadFilters(),

  mutations: {
    SET_FILTERS(state, { list, patch }) {
      state[list] = { ...state[list], ...patch }
      localStorage.setItem(FILTERS_KEY, JSON.stringify({
        evaluations: state.evaluations,
        schools: state.schools,
      }))
    },
    RESET_FILTERS(state, list) {
      state[list] = defaultFilters()[list]
      localStorage.setItem(FILTERS_KEY, JSON.stringify({
        evaluations: state.evaluations,
        schools: state.schools,
      }))
    },
  },

  getters: {
    getFilters: (state) => (list) => state[list],
  },
}

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
    session: session,
    listFilters,
    offline,
  },
})

